import { Injectable } from '@angular/core';
import { Unsubscribable } from '@ats/utility';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import { CmLocalizationService } from './localization.service';

/**
 * @deprecated
 * Manages missing localizations
 * @class CmMissingLocalizationService
 * @property {Observable<string[]>} missingLocalizations$ - An array of localization keys that have been handled
 */
@Injectable({
	providedIn: 'root',
})
export class CmMissingLocalizationService extends Unsubscribable {
	private missingLocalizationSubj$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
	missingLocalizations$: Observable<string[]> = this.missingLocalizationSubj$.asObservable();

	constructor(private localizations: CmLocalizationService) {
		super();
		this.localizations.localization$
			.pipe(
				filter(locs => !!locs),
				switchMap(() => this.localizations.missingLocalization$),
				filter(key => !key?.startsWith('/dev') && key !== '/' && key !== '/undefined'),
				takeUntil(this.unsub)
			)
			.subscribe(locKey => this.handleMissingLocalization(locKey));
	}

	/**
	 * Handles when a missing localization is found
	 * @method
	 * @param {string} key - The localization key
	 * @return {void}
	 */
	handleMissingLocalization(key: string): void {
		const allMissing = this.missingLocalizationSubj$.getValue();
		if (allMissing.includes(key)) {
			return;
		}
		throwError(new Error(`Missing localization: ${key ? key : 'Undefined Key'}`));
		this.missingLocalizationSubj$.next([...allMissing, key]);
	}
}
